export const TECHNICIAN_LABELS = {
  PAGE_TITLE: 'Dodaj technika', // Add Technician
  EDIT_PAGE_TITLE: 'Edytuj technika', // Edit Technician
  SUBMIT_BUTTON: 'Dodaj technika', // Add Technician
  SUBMIT_BUTTON_LOADING: 'Dodawanie technika...', // Adding Technician...
  EDIT_SUBMIT_BUTTON: 'Zapisz', // Save
  EDIT_SUBMIT_BUTTON_LOADING: 'Zapisywanie…', // Saving...
  CANCEL_BUTTON: 'Anuluj', // Cancel
  STATUS_ACTIVE: 'Aktywny', // Active
  STATUS_INACTIVE: 'Nieaktywny', // Inactive
  SECTION_BASIC_INFO: 'Podstawowe dane', // Basic Information
  SECTION_PROFILE_PICTURE: 'Zdjęcie profilowe', // Profile Picture
  SECTION_ADDRESS: 'Dane adresowe', // Address Information
  SECTION_TAX_COMPLIANCE: 'Dane podatkowe i zgodności', // Tax & Compliance Information
  SECTION_DOCUMENTS: 'Dokumenty (opcjonalne)', // Documents (Optional)
  SECTION_ACCESS: 'Dostęp i uprawnienia', // Access & Permissions
  FIELD_NAME: 'Imię i nazwisko', // Full Name
  FIELD_EMAIL: 'Adres e-mail', // Email Address
  FIELD_PHONE: 'Numer telefonu', // Phone Number
  FIELD_ADDRESS1: 'Adres (linia 1)', // Address (Line 1)
  FIELD_ADDRESS2: 'Adres (linia 2)', // Address (Line 2)
  FIELD_CITY: 'Miejscowość', // City
  FIELD_STATE: 'Województwo', // State/Province
  FIELD_ZIP: 'Kod pocztowy', // Postal Code
  FIELD_OPTIONAL: '(Opcjonalne)', // (Optional)
  FIELD_COUNTRY: 'Kraj', // Country
  FIELD_ROLE: 'Rola', // Role
  FIELD_ID_DOCUMENTS: 'Dokumenty tożsamości (max 2)', // Identity Documents (max 2)
  FIELD_GOVERNMENT_ID: 'Identyfikator urzędowy', // Government ID
  FIELD_GOVERNMENT_ID_OPTIONAL: '(Opcjonalne)', // (Optional)
  FIELD_TECHNICIAN_ID: 'ID technika',
  TOOLTIP_PROFILE_PICTURE: 'Wymagania dotyczące zdjęcia profilowego:', // Profile Picture Requirements:
  // Schedule view
  SCHEDULE_VIEW_DAY: 'Dzień',
  SCHEDULE_VIEW_WEEK: 'Tydzień',
  SCHEDULE_VIEW_RANGE: 'Zakres dat',
  SCHEDULE_NAV_PREV: 'Poprzedni okres',
  SCHEDULE_NAV_NEXT: 'Następny okres',
  SCHEDULE_NAV_TODAY: 'Dzisiaj',
  SCHEDULE_REFRESH: 'Odśwież dane',
  SCHEDULE_REFRESH_LOADING: 'Ładowanie…',
  SCHEDULE_TOOLBAR_ARIA: 'Narzędzia kalendarza',
  SCHEDULE_VIEW_GROUP_ARIA: 'Widok kalendarza',
  SCHEDULE_OPEN_DATE_PICKER: 'Wybierz zakres dat',
  SCHEDULE_COLUMN_HEADER: 'Godzina',
  SCHEDULE_FILTER_TECHNICIANS: 'Filtruj techników',
  SCHEDULE_FILTER_DATE_RANGE: 'Zakres dat',
  SCHEDULE_LOADING: 'Loading technician calendar',
  SCHEDULE_SEARCH_PLACEHOLDER: 'Szukaj po ID zgłoszenia',
  MY_TASKS_PAGE_TITLE: 'Moje zadania',
  TOOLTIP_FORMAT: 'Format: PNG, JPG lub JPEG', // Format: PNG, JPG or JPEG
  TOOLTIP_SIZE: 'Maksymalny rozmiar pliku: 5 MB', // Maximum file size: 5 MB
  // Privileges section
  PRIVILEGES_TITLE: 'Uprawnienia',
  PRIVILEGES_SELECT_ALL: 'Select All',
  MODULE_MANAGE_TASKS: 'Manage Assigned Tasks',
  MODULE_CERTIFICATES: 'Certificate Management',
  MODULE_INVOICES: 'Invoice Management',
  PRIV_TASK_LIST: 'List of Assigned Tasks',
  PRIV_TASK_VIEW: 'View Assigned Task Details',
  PRIV_TASK_UPDATE_STATUS: 'Update Task Status',
  PRIV_TASK_FILL_FORM: 'Fill Task Form',
  PRIV_TASK_ACCEPT_REJECT: 'Accept/Reject Task',
  PRIV_CERT_LIST: 'List of Certificates',
  PRIV_CERT_VIEW: 'View Certificate',
  PRIV_CERT_DOWNLOAD: 'Download Certificate',
  PRIV_INVOICE_LIST: 'List of Invoices',
  PRIV_INVOICE_VIEW: 'View Invoice Details',
  PRIV_INVOICE_DOWNLOAD: 'Download Invoice',
} as const;
